import { createContext } from 'react';

const wizardStepContext = createContext({
  currentStep: '',
});

export default wizardStepContext;
